module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cts",
    attrs: {
      "id": "d7e2538"
    }
  }, [_vm._v("TABLE OF CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e26481"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_title2_r1",
      "id": "d14e172"
    }
  }, [_c('i', [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e26482"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_crt4_r1",
      "id": "d14e176"
    }
  }, [_c('i', [_vm._v("Copyright Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e2648"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_ch2_r1#d7e57711",
      "id": "d14e181"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2698"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c8_r1#d7e90615",
      "id": "d14e185"
    }
  }, [_vm._v("PART I: THE INSIDE JOB")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e2748"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c9_r1#d7e92817",
      "id": "d14e189"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OIN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLFER")])]), _c('br'), _vm._v(" "), _c('i', [_c('a', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c9_r1#d7e92817",
      "id": "d14e198"
    }
  }, [_vm._v("Taking on PJ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e2888"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c9_r1#d7e350933",
      "id": "d14e202"
    }
  }, [_vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUEN")])]), _c('br'), _vm._v(" "), _c('i', [_c('a', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c9_r1#d7e350933",
      "id": "d14e211"
    }
  }, [_vm._v("Black Stuff")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e3038"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c9_r1#d7e547445",
      "id": "d14e215"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AT")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULLAN")])]), _c('br'), _vm._v(" "), _c('i', [_c('a', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c9_r1#d7e547445",
      "id": "d14e224"
    }
  }, [_vm._v("Tribunal")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3178"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c10_r1#d7e713659",
      "id": "d14e228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II: THE MANHATTAN CONNECTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e3228"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c11_r1#d7e715861",
      "id": "d14e232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EED")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARREL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLEMAN")])])]), _c('br'), _vm._v(" "), _c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c11_r1#d7e715861",
      "id": "d14e244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Portrait of the Killer As a Young Man")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e3408"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c11_r1#d7e791667",
      "id": "d14e248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETER")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIEGELMAN")])])]), _c('br'), _vm._v(" "), _c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c11_r1#d7e791667",
      "id": "d14e257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Best Part")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e3548"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c11_r1#d7e907476",
      "id": "d14e262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IM")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USILLI")])])]), _c('br'), _vm._v(" "), _c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c11_r1#d7e907476",
      "id": "d14e271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghost of Rory Gallagher")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e3688"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c11_r1#d7e1133491",
      "id": "d14e275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASON")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TARR")])])]), _c('br'), _vm._v(" "), _c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c11_r1#d7e1133491",
      "id": "d14e284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lost in Dublin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e3838"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c11_r1#d7e13065103",
      "id": "d14e288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARLIE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TELLA")])])]), _c('br'), _vm._v(" "), _c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c11_r1#d7e13065103",
      "id": "d14e297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tainted Goods")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3978"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c12_r1#d7e14491115",
      "id": "d14e301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III: HEART OF THE OLD COUNTRY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e4028"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c13_r1#d7e14512117",
      "id": "d14e304",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANKS")])])]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c13_r1#d7e14512117",
      "id": "d14e313",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Wrong ’Em, Boyo")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e4168"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c13_r1#d7e16087128",
      "id": "d14e318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEINHAUER")])])]), _c('br'), _vm._v(" "), _c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c13_r1#d7e16087128",
      "id": "d14e327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Piss-Stained Czech")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e4339"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c13_r1#d7e17373136",
      "id": "d14e331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICKARDS")])])]), _c('br'), _vm._v(" "), _c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c13_r1#d7e17373136",
      "id": "d14e340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wish")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e4479"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c13_r1#d7e18532144",
      "id": "d14e344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVIN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGNALL")])])]), _c('br'), _vm._v(" "), _c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c13_r1#d7e18532144",
      "id": "d14e353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Death of Jeffers")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e4619"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c14_r1#d7e19921155",
      "id": "d14e357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV: NEW WORLD NOIR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e4669"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c15_r1#d7e19942157",
      "id": "d14e361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AURA")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IPPMAN")])])]), _c('br'), _vm._v(" "), _c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c15_r1#d7e19942157",
      "id": "d14e370",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Honor Bar")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e4809"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c15_r1#d7e22158173",
      "id": "d14e374",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(" O. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORN")])])]), _c('br'), _vm._v(" "), _c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c15_r1#d7e22158173",
      "id": "d14e383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tourist Trade")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e4959"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c15_r1#d7e23494183",
      "id": "d14e388",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARAH")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EINMAN")])])]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c15_r1#d7e23494183",
      "id": "d14e396",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Hen Night")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e5099"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c15_r1#d7e24747192",
      "id": "d14e401",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILLIPS")])])]), _c('br'), _vm._v(" "), _c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c15_r1#d7e24747192",
      "id": "d14e410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Man for the Job")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e5239"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c15_r1#d7e26816207",
      "id": "d14e414",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATRICK")]), _vm._v(" J. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMBE")])])]), _c('br'), _vm._v(" "), _c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c15_r1#d7e26816207",
      "id": "d14e423",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Prosperity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e5379"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c15_r1#d7e27364212",
      "id": "d14e427",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UANE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WIERCZYNSKI")])])]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c15_r1#d7e27364212",
      "id": "d14e435",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Lonely and Gone")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e5519"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c15_r1#d7e28562219",
      "id": "d14e440",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAIG")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONALD")])])]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c15_r1#d7e28562219",
      "id": "d14e448",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Rope-A-Dope")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "d7e5699"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Brue_ISBN9781936070282_epub_c16_r1#d7e30165230",
      "id": "d14e453",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Contributors")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac56e242","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Brue_ISBN9781936070282_epub_con6_r1.vue
// module id = 75
// module chunks = 0